import styled from "styled-components";

export const Styles = styled.div`
  .field-section {
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    label {
      font-size: 1rem;
      span {
        margin-left: 4px;
        color: #e74c3c;
        font-size: 20px;
      }
    }
    .ant-input {
      border: 1px solid #e3e7e8;
      box-shadow: inset 2px 2px 4px #f5f5f5, inset -2px -2px 4px #f5f5f5;
      color: #888;
      font-size: 14px;
      &.is-error {
        border-color: #e74c3c;
      }
    }
  }
`;
